import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../ui/Button';
import ActionMessage from './ActionMessage';
import { AssociatedContent } from './types';

const AssignContent = ({
  assignAllContent,
  sessions,
  associatedContent,
  event,
}) => {
  const { contentItems, loading } = associatedContent;
  const isDisabled = !sessions[sessions.length - 1].session_ended;

  const allContentAssigned =
    !isDisabled &&
    !!contentItems.length &&
    contentItems.every(item => item.assigned_at);

  return (
    !loading &&
    !!contentItems.length && (
      <div className="mt-16">
        {allContentAssigned ? (
          <ActionMessage
            message={
              event.is_archived
                ? t('in_person_training.event_content.success_message_archived')
                : t('in_person_training.event_content.success_message')
            }
          />
        ) : (
          <Button
            customColor
            onClick={() => assignAllContent()}
            a11yDisabled={isDisabled || event.is_archived}
            a11yDisabledTooltip={
              event.is_archived
                ? t('in_person_training.event_content.disabled_archived')
                : t('in_person_training.event_content.disabled_event_not_ended')
            }
          >
            {t('in_person_training.event_content.assign_to_attendees')}
          </Button>
        )}
      </div>
    )
  );
};

AssignContent.propTypes = {
  associatedContent: AssociatedContent,
  assignAllContent: PropTypes.func,
  sessions: PropTypes.arrayOf(PropTypes.shape({})),
  event: PropTypes.shape({}),
};

export default AssignContent;
